// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__q4mdY","text":"SelectPayment_text__9ZL6P","title":"SelectPayment_title__22wUO","btn":"SelectPayment_btn__42PVh"};